@if ($isMobile() && collapsible()) {
  <h5
    (click)="toggleCollapse()"
    [ngClass]="{ 'is-collapsed': isCollapsed && collapsible() }"
  >
    @if (isCollapsed) {
      {{ 'addToCart.cart.accessories.showAccessories' | transloco }}
      ({{ accessoriesCount() }})
      <fa-icon [icon]="faChevronDown"></fa-icon>
    } @else {
      {{ 'addToCart.cart.accessories.hideAccessories' | transloco }}
      ({{ accessoriesCount() }})
      <fa-icon [icon]="faChevronUp"></fa-icon>
    }
  </h5>
} @else {
  <h5>
    {{ 'addToCart.cart.accessories.accessories' | transloco }}
  </h5>
}

<div [@collapse]="isCollapsed ? 'collapsed' : 'expanded'">
  <ng-content></ng-content>
</div>
